import {
  darkTheme, type GlobalThemeOverrides,
  unstableAlertRtl, unstableButtonRtl, unstableCardRtl, unstableCheckboxRtl, unstableDataTableRtl, unstableDialogRtl,
  unstableDrawerRtl, unstableInputNumberRtl, unstableInputRtl, unstableMessageRtl,
  unstableNotificationRtl, unstablePaginationRtl, unstablePopoverRtl, unstableRadioRtl, unstableScrollbarRtl,
  unstableSelectRtl, unstableSpaceRtl, unstableStatisticRtl, unstableTableRtl, unstableTabsRtl, unstableTagRtl,
} from 'naive-ui';

export { darkTheme };

/**
 * RTL styles for every Naive UI component the panel uses — except InputOtp: codes are read
 * left-to-right, so its boxes must fill from the left.
 */
export const rtl = [
  unstableAlertRtl, unstableButtonRtl, unstableCardRtl, unstableCheckboxRtl, unstableDataTableRtl, unstableDialogRtl,
  unstableDrawerRtl, unstableInputNumberRtl, unstableInputRtl, unstableMessageRtl,
  unstableNotificationRtl, unstablePaginationRtl, unstablePopoverRtl, unstableRadioRtl, unstableScrollbarRtl,
  unstableSelectRtl, unstableSpaceRtl, unstableStatisticRtl, unstableTableRtl, unstableTabsRtl, unstableTagRtl,
];

/** Artiman design tokens (dark theme of the website) mapped onto Naive UI. */
export const AZ = {
  bg: '#080B10', surface: '#0B0F16', card: '#0F151F', raised: '#101722', border: '#232E3D', borderSoft: '#1D2734',
  text: '#F2F6FC', textSoft: '#D8E1EC', muted: '#8B9AAF', accent: '#E0B252', accentHover: '#F2CB7C', accentPressed: '#B07F14',
  up: '#3FD18B', down: '#FF7B72', info: '#5B9BD5',
};

export const themeOverrides: GlobalThemeOverrides = {
  common: {
    fontFamily: 'Vazirmatn, system-ui, sans-serif',
    fontFamilyMono: 'ui-monospace, SFMono-Regular, Menlo, monospace',
    primaryColor: AZ.accent, primaryColorHover: AZ.accentHover, primaryColorPressed: AZ.accentPressed, primaryColorSuppl: AZ.accent,
    infoColor: AZ.info, successColor: AZ.up, warningColor: AZ.accent, errorColor: AZ.down,
    errorColorHover: '#FF968F', successColorHover: '#62DDA2',
    bodyColor: AZ.bg, cardColor: AZ.card, modalColor: AZ.card, popoverColor: AZ.raised, tableColor: AZ.card,
    inputColor: '#0B1019', borderColor: AZ.border, dividerColor: AZ.borderSoft,
    textColorBase: AZ.text, textColor1: AZ.text, textColor2: AZ.textSoft, textColor3: AZ.muted,
    borderRadius: '10px', borderRadiusSmall: '8px', fontSize: '14px', fontSizeMedium: '14px',
  },
  Button: { textColorPrimary: '#12100A', textColorHoverPrimary: '#12100A', textColorPressedPrimary: '#12100A', textColorFocusPrimary: '#12100A', fontWeight: '700' },
  Card: { borderRadius: '18px', colorEmbedded: AZ.raised, borderColor: AZ.border },
  DataTable: { thColor: AZ.raised, tdColor: AZ.card, tdColorHover: '#141C28', borderColor: AZ.borderSoft, thFontWeight: '700' },
  Tag: { borderRadius: '8px' },
  // Same field look as the website (alert modal inputs): dark well, visible border, gold focus.
  Input: {
    heightMedium: '42px', borderRadius: '12px', color: '#0B1019', colorFocus: '#0B1019',
    border: '1px solid #26323F', borderHover: '1px solid #3A4757', borderFocus: '1px solid #E0B252',
    boxShadowFocus: '0 0 0 2px rgba(224,178,82,.18)',
  },
  InternalSelection: {
    color: '#0B1019', border: '1px solid #26323F', borderHover: '1px solid #3A4757', borderFocus: '1px solid #E0B252',
    borderActive: '1px solid #E0B252', boxShadowFocus: '0 0 0 2px rgba(224,178,82,.18)', boxShadowActive: '0 0 0 2px rgba(224,178,82,.18)',
  },
  Tabs: { tabTextColorActiveLine: AZ.accent, barColor: AZ.accent },
};
